module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Horizontal-f0b6f057d396079a0e9d8fd71d76d820.svg";